import AttachmentUpload from './AttachmentUpload';

export default AttachmentUpload;
export * from './AttachmentUpload';
